import React, {useContext} from 'react';

import {AppContext} from '../../../../../AppModule/Context';

import ShimmerComponent from '../../../shimmerComponent/shimmerComponent';

import utilsService from '../../../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../../../config/consts';

import './leadsFormShimmerComponent.css';

const LeadsFormShimmerComponent = () => {
  const context = useContext(AppContext);

  return (
    <div
      className={`et-v2-leads-form-shimmer-container ${
        utilsService.getIsPersonalPage() &&
        context.windowScreenSize !== VIDABOO_CONSTANTS.SCREEN_SIZE.MOBILE
          ? 'et-v2-leads-form-shimmer-container-pp'
          : ''
      }`}>
      <div className="et-v2-lfsc-automatic-msg">
        <ShimmerComponent />
      </div>
      <div className="et-v2-ifsc-input-field">
        <ShimmerComponent />
      </div>
      <div className="et-v2-ifsc-input-field">
        <ShimmerComponent />
      </div>
      <div className="et-v2-ifsc-textarea-field">
        <ShimmerComponent />
      </div>
      <div className="et-v2-ifsc-consent">
        <div className="et-v2-ifsc-consent-checkbox">
          <ShimmerComponent />
        </div>
        <div className="et-v2-ifsc-consent-txt-wrap">
          <div className="et-v2-ifsc-consent-txt">
            <ShimmerComponent />
          </div>
          <div className="et-v2-ifsc-consent-txt">
            <ShimmerComponent />
          </div>
          <div className="et-v2-ifsc-consent-txt">
            <ShimmerComponent />
          </div>
        </div>
      </div>
      <div className="et-v2-ifsc-send-btn">
        <ShimmerComponent />
      </div>
    </div>
  );
};

export default LeadsFormShimmerComponent;
